import React from 'react'

export const AdminProducts = () => {
  return <>Products</>
}
